/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Col_CheckInputs */

const en_directory_agent_readiness_col_check = /** @type {(inputs: Directory_Agent_Readiness_Col_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check`)
};

const zh_directory_agent_readiness_col_check = /** @type {(inputs: Directory_Agent_Readiness_Col_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查项`)
};

/**
* | output |
* | --- |
* | "Check" |
*
* @param {Directory_Agent_Readiness_Col_CheckInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_col_check = /** @type {((inputs?: Directory_Agent_Readiness_Col_CheckInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Col_CheckInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_col_check(inputs)
	return zh_directory_agent_readiness_col_check(inputs)
});
export { directory_agent_readiness_col_check as "directory.agent_readiness.col.check" }